import { createFileRoute } from '@tanstack/react-router'

import { TrackingDocumentationPage } from '../../../components/pages/backoffice/platform/platform-documentation/tracking-documentation-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/tracking-doc')({
  component: () => (
    <PermissionChecker requiredPermissions={['tracking.read']}>
      <TrackingDocumentationPage />
    </PermissionChecker>
  ),
})
